<template>
    <div class="m-qa">
        <ul>
            <li v-for="(item,index) in qa_txt" :key="'line-' + index">
                <div class="txt_q">                   
                    <p><em class="icon icon-q">Q：</em><span v-html="item.q"></span></p>
                </div>
                <div class="txt_a">                    
                    <p><em class="icon icon-a">A:</em><span v-html="item.a"></span></p>
                </div>
            </li>
        </ul>
    </div>
</template>

<style>
.m-qa ul{
    width: 1002px;
    margin: 0 auto;
    padding-top: 22px;
    background-color: #523f1a;
    border: 1px solid #785a15;
}

.m-qa li{
    margin-bottom: 20px;
    padding: 0 40px 10px;
    padding-bottom: 10px;
    line-height: 2;
}

.m-qa li p{
    position: relative;
    padding-left: 25px;
    font-family: 'Adobe 黑体 Std','Microsoft Yahei';
    font-size: 16px;
    color: #bca864;
}

.m-qa .icon{
    position: absolute;
    left: 0;
    top: 0;
    display: block;    
    font-weight: 700;
    font-family: 'Impact';
}
</style>

<script>
export default {
    name : 'm-qa',
    data : function(){
        return {
            qa_txt : [{
                'q' : '报名时历史最高神兵值的要求是？',
                'a' : '个人最高历史神兵值≥35万。'
            },{
                'q' : '巅峰对决赛的资格如何获得？',
                'a' : '报名结束后，仅战队历史最高神兵值排名前32的战队将有资格参加巅峰对决赛。官方将按照队伍有效报名所有成员的平均神兵作为队伍神兵进行排序。'
            },{
                'q' : '历史最高神兵值指的是什么？',
                'a' : '历史最高神兵值取决于报名账号的最高神兵值，而不是当前装备方案的神兵值。'
            },{
                'q' : '每支战队报名需要多少队员？',
                'a' : '报名以战队为单位，每支战队不得低于10名成员，最多可报12名成员，其中2名为替补队员。'
            },{
                'q' : '“巅峰对决赛”和“装备大师赛”的区别是？',
                'a' : '报名结束后，仅战队历史最高神兵值排名前32名的战队可获得“巅峰对决赛”参赛资格，其余战队将默认参与“装备大师赛”。'
            },{
                'q' : '装备大师赛的意思是？',
                'a' : '赛事主办方将在比赛服内提供的统一装备，战队选手可通过自身对装备的理解进行自由配置，与各路高手一决高下。'
            },{
                'q' : '忘记战队码或不知道自己队员是否提交报名信息，如何查询？',
                'a' : '登录报名页面→赛事报名→战队列表，即可看到队内成员信息提交状态和战队码。'
            },{
                'q' : '队长完成创建战队后，队员如何加入战队？',
                'a' : '队长将战队码告知队员，队员登录页面→我要报名→我是队员，加入战队→填写战队码→正确填写并提交个人信息→加入比赛通知群。'
            },{
                'q' : '报名截止后，队内不满足10人确认报名信息，战队报名是否有效？',
                'a' : '报名结束后，队内成员填报提交个人信息满足≥10人，代表报名成功，若＜10人则代表报名无效，战队没有参赛资格。</br>报名结束后，满足队伍报名成功条件，但战队中存在未提交报名信息的队员，则其个人将不会获得参赛资格与奖励。'
            },{
                'q' : '报名时没有填报替补，报名结束前可增加替补吗？',
                'a' : '报名结束前，队内如有替补空余位置，队长有权增加替补队员。</br>增加方式：队长登录报名页面→赛事报名→战队列表→添加替补→填报替补ID并提交→告知替补战队码→替补登录报名页面，进行“加入战队，填报提交个人信息”流程。'
            },{
                'q' : '参与奖如何获得？',
                'a' : '完成一场有效对局（无论输赢）即可获得参与奖一份，奖励不可重复获得，只取最高名次奖励。'
            },{
                'q' : '替补队员奖励是否与正式队员奖励一致？',
                'a' : '替补队员未进行有效对局则不可获得任何奖励，当替补队员进行一场有效对局后则可获得与正式队员同等道具奖励，涉及替补奖金分配问题详情请见赛事规则。'
            },{
                'q' : '约战令如何发放？是所有的参赛人员都会有吗？',
                'a' : '报名结束后官方将统一发放足量的约战令至战队队长的比赛账号中。'
            },
            ],
        }
    }, 
}
</script>


// WEBPACK FOOTER //
// src/components/qa.vue